<template>
  <div>
    <div class="header-2">
      <div class="page-header header-filter">
        <div 
          :style="{backgroundImage: 'url(' + options.defaultAirport.backgroundImageUrl + ')'}"
          class="page-header-image" 
          style="background-image: url('img/bg-default.png')"/>
        <div class="content-center">
          <div class="container">
            <div class="row">
              <div class="col-md-10 ml-auto mr-auto text-center">
                <h1 class="title">Settings</h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row justify-content-center my-4">
        <div class="col-md-6">
          <div class="row align-items-start">
            <div class="col-md-6">
              <ValidationProvider
                name="First Name" 
                rules="required">
                <div slot-scope="{ errors, valid }">
                  <label>First Name</label>
                  <fg-input 
                    :value="firstName" 
                    :error="errors[0]"
                    type="text"
                    addon-left-icon="now-ui-icons users_circle-08"
                    placeholder="First Name"
                    @input="firstName=$event.target.value"
                    @blur="onBlur('firstName', valid)"/>
                </div>
              </ValidationProvider>
            </div>
            <div class="col-md-6">
              <ValidationProvider 
                name="Last Name" 
                rules="required">
                <div slot-scope="{ errors, valid }">
                  <label>Last Name</label>
                  <fg-input 
                    :value="lastName" 
                    :error="errors[0]"
                    type="text"
                    addon-left-icon="now-ui-icons users_circle-08"
                    placeholder="Last Name"
                    @input="lastName=$event.target.value"
                    @blur="onBlur('lastName', valid)"/>
                </div>
              </ValidationProvider>
            </div>
            <div class="col-md-6">
              <ValidationProvider 
                name="Email" 
                rules="required|email">
                <div slot-scope="{ errors, valid }">
                  <label>Email</label>
                  <fg-input
                    :value="email" 
                    :error="errors[0]"
                    addon-left-icon="now-ui-icons ui-1_email-85"
                    placeholder="Email"
                    @input="email=$event.target.value"
                    @blur="onBlur('email', valid)"/>
                </div>
              </ValidationProvider>
            </div>
            <div class="col-md-6">
              <ValidationProvider 
                :rules="{required: true, regex: phoneRegex}"
                name="Phone">
                <div slot-scope="{ errors, valid }">
                  <label>Phone</label>
                  <fg-input 
                    :value="phoneNumber" 
                    :error="errors[0]"
                    type="tel"
                    addon-left-icon="now-ui-icons tech_mobile"
                    placeholder="Phone"
                    @input="phoneNumber=$event.target.value"
                    @blur="onBlur('phoneNumber', valid)"/>
                </div>
              </ValidationProvider>
            </div>
          </div>
          <div class="row mt-5">
            <div class="col-md-6">
              <n-button
                type="primary"
                block
                @click.native="openPasswordModal=true">
                Change Password
              </n-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <WarningModal 
      :open="openWarningModal"
      :title="title" 
      @close="onClose" 
      @submit="onSubmit" />
    <ChangePasswordModal 
      :open="openPasswordModal" 
      @close="openPasswordModal=false" />
  </div>
</template>
<script>
  import axios from 'axios';
  import { mapState, mapMutations } from 'vuex';
  import { Button, Card, FormGroupInput } from '@/components';
  import ChangePasswordModal from '@/pages/components/ChangePasswordModal.vue';
  import WarningModal from '@/pages/components/WarningModal.vue';
  import { PHONE_REGEX } from '@/constants';

  export default {
    components: {
      Card,
      [Button.name]: Button,
      [FormGroupInput.name]: FormGroupInput,
      ChangePasswordModal,
      WarningModal,
    },
    data() {
      return {
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        phoneRegex: PHONE_REGEX,
        field: '',
        openPasswordModal: false,
        openWarningModal: false,
        title: 'Are you sure want to change your email?',
        openCardModal: false,
      };
    },
    computed: {
      ...mapState([
        'options',
        'member'
      ]),
    },
    watch: {
      member() {
        this.firstName = this.member.firstName;
        this.lastName = this.member.lastName;
        this.email = this.member.email;
        this.phoneNumber = this.member.phoneNumber;
      }
    },
    created() {
      this.firstName = this.member.firstName;
      this.lastName = this.member.lastName;
      this.email = this.member.email;
      this.phoneNumber = this.member.phoneNumber;
      this.setLoading(false);
    },
    methods: {
      ...mapMutations([
        'setLoading',
        'setMember'
      ]),
      onBlur(field, valid) {
        this.field = field;
        if (valid && this[field] !== this.member[field]) {
          if (field === 'email') {
            this.openWarningModal = true;
          } else {
            this.callback();
          }
        }
      },
      onSubmit() {
        this.callback();
      },
      callback() {
        const url = `member/${this.field}`;
        axios.put(url, {
          [this.field]: this[this.field]
        }).then(res => {
          const member = {
            ...this.member,
            [this.field]: this[this.field]
          };
          localStorage.setItem('member', JSON.stringify(member));
          this.setMember(member);
          this.field = '';
          this.openWarningModal = false;
        }).catch(err => {
          console.error('member/firstName: ', err.response);
          this[this.field] = this.member[this.field];
          this.field = '';
          this.openWarningModal = false;
        })
      },
      onClose() {
        this[this.field] = this.member[this.field];
        this.field = '';
        this.openWarningModal = false;
      }
    }
  }
</script>
<style lang='scss' scoped>
  .page-header {
    min-height: 25vh !important;

    .page-header-image {
      background-position: center center !important;
    }

    .container {
      text-align: left !important;

      .title {
        @media (max-width: 771px) {
          font-size: 2.25em;
        }
      }
    }
  }

  .cc-icon {
    height: 20px;
  }
  .cc-number {
    font-size: 1.1em;
    font-weight: bold;
  }
  .cc-expire {
    font-size: 0.9em;
    font-weight: normal;
    text-align: right;
  }
</style>
